import { makeObservable, observable, runInAction, action, computed } from 'mobx';
import { ExpenseService } from '../services/expenseServices';
import i18n from 'i18next';
import { toast } from "react-toastify";

export default class ExpensesWithPakageFormStore {

    rootStore;

    packageExpense = {
        items: []
    };

    criteria = {
        devId: undefined
    };

    isLoading = false;

    constructor(rootStore) {
        this.rootStore = rootStore;

        makeObservable(this, {
            packageExpense: observable,
            isLoading: observable,
            criteria: observable,
            getPackageExpense: action,
            save: action,
            generate: action,
            getTotalKms: computed,
            getTotalBreakfast: computed,
            getTotalLunch: computed,
            getTotalDinner: computed,
            getTotalLodging: computed,
            getTotalPhoneAndITPackage: computed,
        });
    }

    getPackageExpense = async (year, month, devId) => {
        try {
            
            runInAction(() => {
                this.isLoading = true;
                this.criteria.month = month;
                this.criteria.year = year;
                this.criteria.devId = devId;
            });

            var data = await ExpenseService.getPackageExpense(this.criteria);

            runInAction(() => {
                this.packageExpense = data;
            });
        } catch {
            runInAction(() => {
                this.packageExpense = {
                    items: []
                };
            });
        } finally {
            runInAction(() => {
                this.isLoading = false;
            });
        }
    }

    generate = async () => {
        try {

            runInAction(() => {
                this.isLoading = true;
            });

            var data = await ExpenseService.generatePackageExpenseDataByYearAndMonth(this.criteria);

            runInAction(() => {
                this.packageExpense = data;
            });
        } catch {
            runInAction(() => {
            });
        } finally {
            runInAction(() => {
                this.isLoading = false;
            });
        }
    }

    save = async () => {
        try {

            runInAction(() => {
                this.isLoading = true;
            });

            for (var i = 0; i < this.packageExpense.items.length; i++) {
                if (!this.packageExpense.items[i].kms || this.packageExpense.items[i].kms === "-")
                    this.packageExpense.items[i].kms = 0;

                if (!this.packageExpense.items[i].breakfast || this.packageExpense.items[i].breakfast === "-")
                    this.packageExpense.items[i].breakfast = 0;

                if (!this.packageExpense.items[i].lunch || this.packageExpense.items[i].lunch === "-")
                    this.packageExpense.items[i].lunch = 0;

                if (!this.packageExpense.items[i].dinner || this.packageExpense.items[i].dinner === "-")
                    this.packageExpense.items[i].dinner = 0;

                if (!this.packageExpense.items[i].lodging || this.packageExpense.items[i].lodging === "-")
                    this.packageExpense.items[i].lodging = 0;

                if (!this.packageExpense.items[i].phoneAndITPackage || this.packageExpense.items[i].phoneAndITPackage === "-")
                    this.packageExpense.items[i].phoneAndITPackage = 0;
            }
            

            var data = await ExpenseService.save(this.packageExpense);
            runInAction(() => {
                toast.success(i18n.t('internalExpensesWithPackageSavedSuccessfully'));
                this.getPackageExpense(this.criteria.year, this.criteria.month, this.criteria.devId)
                    .then(() => {

                    });
            });
        } catch {
            runInAction(() => {
            });
        } finally {
            runInAction(() => {
                this.isLoading = false;
            });
        }
    }

    get getTotalKms() {
        return this.packageExpense.items.map((item) => item.kms).reduce((previousValue, currentValue) => parseFloat(previousValue) + (currentValue != null && currentValue != "" && !isNaN(currentValue) ? parseFloat(currentValue) : 0), 0);
    }

    get getTotalBreakfast() {
        return this.packageExpense.items.map((item) => item.breakfast).reduce((previousValue, currentValue) => parseFloat(previousValue) + (currentValue != null && currentValue != "" &&!isNaN(currentValue) ? parseFloat(currentValue) : 0), 0);
    }

    get getTotalLunch() {
        return this.packageExpense.items.map((item) => item.lunch).reduce((previousValue, currentValue) => parseFloat(previousValue) + (currentValue != null && currentValue != "" &&!isNaN(currentValue) ? parseFloat(currentValue) : 0), 0);
    }

    get getTotalDinner() {
        return this.packageExpense.items.map((item) => item.dinner).reduce((previousValue, currentValue) => parseFloat(previousValue) + (currentValue != null && currentValue != "" &&!isNaN(currentValue) ? parseFloat(currentValue) : 0), 0);
    }

    get getTotalLodging() {
        return this.packageExpense.items.map((item) => item.lodging).reduce((previousValue, currentValue) => parseFloat(previousValue) + (currentValue != null && currentValue != "" &&!isNaN(currentValue) ? parseFloat(currentValue) : 0), 0);
    }

    get getTotalPhoneAndITPackage() {
        return this.packageExpense.items.map((item) => item.phoneAndITPackage).reduce((previousValue, currentValue) => parseFloat(previousValue) + (currentValue != null && currentValue != "" &&!isNaN(currentValue) ? parseFloat(currentValue) : 0), 0);
    }
}